export const environment = {
  recaptcha: {
    siteKey: "6Ld7EPcpAAAAAP4JURU8Y8N6UV4vDtoPGSsT2MBh",
  },
  production: true,
  staging: false,
  imageApiBaseUrl: "containers",
  appURL: "https://config.theappsherpa.com",
};
